import ValidationInterface from '@/plans/common/validation-interface';
import { basePlanCategories, SDKCategories } from '@/common/persist-cart/categories';

export default class extends ValidationInterface {
  async requires() {
    return [this.current('did').require([...basePlanCategories, ...SDKCategories])];
  }

  async conflicts() {
    return this.current(['did']).conflict(['did']);
  }
}
